import Route from '@ember/routing/route';

export default class VisitorProfilesIndexRoute extends Route {}
